(function () {
  'use strict';

  const AttributionMonitor = {
    sessionId: null,
    events: [],
    errors: [],

    init: function () {
      this.sessionId = this.getSessionId();
      this.trackSession();
      this.monitorConversions();
      this.setupBeforeUnload();
    },

    getSessionId: function () {
      try {
        let sid = sessionStorage.getItem('attribution_session_id');
        if (!sid) {
          sid = 'sess_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
          sessionStorage.setItem('attribution_session_id', sid);
        }
        return sid;
      } catch (_e) {
        return 'sess_' + Date.now();
      }
    },

    trackSession: function () {
      const urlParams = new URLSearchParams(window.location.search);
      const hasUTM = urlParams.has('utm_source') || urlParams.has('utm_medium');
      const hasFbclid = urlParams.has('fbclid');
      const hasGclid = urlParams.has('gclid');
      const hasAnyTracking = hasUTM || hasFbclid || hasGclid;

      // Check if attribution was captured
      let attribution = null;
      try {
        const data = sessionStorage.getItem('attribution');
        attribution = data ? JSON.parse(data) : null;
      } catch (_e) {
        // No attribution data available
      }

      // Detect attribution failures
      if (hasAnyTracking && !attribution) {
        this.logError('attribution_lost', {
          had_utm: hasUTM,
          had_fbclid: hasFbclid,
          had_gclid: hasGclid,
          url: window.location.href,
        });
      }

      // Check analytics loading
      setTimeout(function () {
        const ga4Loaded = typeof window.gtag === 'function';
        const fbLoaded = typeof window.fbq === 'function';

        if (hasAnyTracking) {
          if (!ga4Loaded) {
            AttributionMonitor.logError('ga4_not_loaded', {
              timeout: 5000,
              had_tracking: true,
            });
          }
          if (!fbLoaded && hasFbclid) {
            AttributionMonitor.logError('fb_pixel_not_loaded', {
              timeout: 5000,
              had_fbclid: true,
            });
          }
        }

        // Track attribution coverage
        AttributionMonitor.trackCoverage({
          has_tracking_params: hasAnyTracking,
          attribution_captured: !!attribution,
          ga4_loaded: ga4Loaded,
          fb_loaded: fbLoaded,
          source: attribution ? attribution.source : 'unknown',
          medium: attribution ? attribution.medium : 'unknown',
        });
      }, 5000); // Wait 5 seconds for analytics to load
    },

    monitorConversions: function () {
      const self = this;

      // Monitor add to cart events
      document.addEventListener('cart:item-added', function (e) {
        self.validateConversionAttribution('add_to_cart', e.detail);
      });

      // Monitor checkout events
      const checkoutButtons = document.querySelectorAll('[name="checkout"], .checkout-button');
      checkoutButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          self.validateConversionAttribution('begin_checkout', {});
        });
      });
    },

    validateConversionAttribution: function (eventType, _eventData) {
      let attribution = null;
      try {
        const data = sessionStorage.getItem('attribution');
        attribution = data ? JSON.parse(data) : null;
      } catch (_e) {
        // No attribution data available
      }

      if (!attribution || attribution.source === 'direct') {
        // Conversion without proper attribution
        this.logError('conversion_without_attribution', {
          event_type: eventType,
          session_started_with_tracking: this.hadTrackingParams(),
          current_url: window.location.href,
        });
      } else {
        // Successful conversion with attribution
        this.events.push({
          type: 'conversion_with_attribution',
          event_type: eventType,
          source: attribution.source,
          medium: attribution.medium,
          campaign: attribution.campaign,
          timestamp: Date.now(),
        });
      }
    },

    hadTrackingParams: function () {
      try {
        const stored = sessionStorage.getItem('utm_sanitizer');
        return !!stored;
      } catch (_e) {
        return false;
      }
    },

    trackCoverage: function (data) {
      // Send coverage metrics to GA4
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'attribution_coverage', {
          event_category: 'Attribution Monitoring',
          has_tracking_params: data.has_tracking_params,
          attribution_captured: data.attribution_captured,
          ga4_loaded: data.ga4_loaded,
          fb_loaded: data.fb_loaded,
          source: data.source,
          medium: data.medium,
          session_id: this.sessionId,
        });
      }
    },

    logError: function (errorType, errorData) {
      this.errors.push({
        type: errorType,
        data: errorData,
        timestamp: Date.now(),
        url: window.location.href,
        session_id: this.sessionId,
      });

      // Send to GA4
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'attribution_error', {
          event_category: 'Attribution Monitoring',
          error_type: errorType,
          error_data: JSON.stringify(errorData),
          session_id: this.sessionId,
          non_interaction: true,
        });
      }
    },

    setupBeforeUnload: function () {
      const self = this;
      window.addEventListener('beforeunload', function () {
        self.reportSummary();
      });
    },

    reportSummary: function () {
      const summary = {
        session_id: this.sessionId,
        events: this.events.length,
        errors: this.errors.length,
        error_types: this.errors.map(function (err) {
          return err.type;
        }),
        duration: Date.now() - (this.events[0] ? this.events[0].timestamp : Date.now()),
      };

      // Send summary to GA4
      if (typeof window.gtag === 'function' && this.errors.length > 0) {
        window.gtag('event', 'attribution_session_summary', {
          event_category: 'Attribution Monitoring',
          total_errors: this.errors.length,
          error_types: summary.error_types.join(','),
          session_id: this.sessionId,
          non_interaction: true,
        });
      }
    },
  };

  // Initialize on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      AttributionMonitor.init();
    });
  } else {
    AttributionMonitor.init();
  }

  // Make available globally for debugging
  window.AttributionMonitor = AttributionMonitor;
})();
